<template>
    <div class="kcc-new-center">
        <div class="news-container border-normal">
            <div class="flex item-center mb-10">
                <img class="" src="@/assets/img/icon-news.svg">
                <div class="font-bold ml-10">{{$t('newsMgt.title1')}}</div>
            </div>
            <el-carousel arrow="never" :autoplay="false">
                <el-carousel-item v-for="item in newsList" :key="item.id">
                <div class="flex">
                    <img v-if="item.newsImage" :src='`data:image/png;base64,${item.newsImage}`' class="news-pic">
                    <div class="ml-10">
                        <p class="font-bold mb-10">{{ item.newsTitle }}</p>
                        <p class="news-desc">{{ item.newsDesc }}</p>
                    </div>
                </div>
                <a class="new-link" @click="toOuterLink(item.linkUrl)">
                    <img class="mr-5" src="@/assets/img/icon-link.svg">
                    <span class="link-title">{{item.linkText}}</span>
                </a>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="onboard-container">
            <div class="flex item-center mb-10">
                <img class="" src="@/assets/img/icon-onboard.svg">
                <div class="font-bold ml-10">{{$t('newsMgt.title2')}}</div>
            </div>
            <div class=" mb-10">{{$t('newsMgt.videoIntroduction')}}</div>
            <div class="flex bottom-splitLine">
                <div class="border-normal mr-10 flex p-15 w-50">
                    <img class="mr-10 video-fill" src="@/assets/img/icon-video-fill.svg">
                    <div>
                        <div>
                            {{ $t('newsMgt.videoList.introduction') }}
                        </div>
                        <a class="onboard-link" @click="toOuterLink(video_En)">{{ $t('newsMgt.videoList.en') }}</a>
                        <a class="onboard-link" @click="toOuterLink(video_Cn)">{{ $t('newsMgt.videoList.cn') }}</a>
                        <a class="onboard-link" @click="toOuterLink(video_yueyu)">{{ $t('newsMgt.videoList.yueyu') }}</a>
                    </div>
                </div>
                <div class="border-normal flex p-15 flex-1 pointer" @click="toOuterLink(video_title)">
                    <img class="mr-10 video-fill" src="@/assets/img/icon-video-fill.svg">
                    <div>
                        <div>{{ $t('newsMgt.videoList.newlyLaunched') }}</div>
                    </div>
                </div>
            </div>
            <div class=" mb-10 mt-10">{{$t('newsMgt.materials')}}</div>
            <el-carousel arrow="always" :autoplay="false">
                <el-carousel-item v-for="(item,index) in materialsList" :key="index">
                    <div class="flex" >
                        <div v-for="child in item" :key="child.id" class="w-32 pointer" @click="toOuterLink(child.linkUrl)">
                            <img v-if="child.materialImage" :src='`data:image/png;base64,${child.materialImage}`' class="w-full material-pic">
                            <p class="material-title">{{ child.materialTitle }}</p>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div class="learning-course pointer" @click="toOuterLink(eLearningUrl)">
                <img class="mr-10" src="@/assets/img/icon-elearning.svg">
                {{ $t('newsMgt.learningCourse') }}
            </div>
        </div>
        
        <div class="training-container flex">
            <div class="document-container">
                <div class="flex item-center mb-5">
                <img class="" src="@/assets/img/icon-communicate.svg">
                <div class="font-bold ml-10">{{$t('newsMgt.title3')}}</div>
            </div>
            <div class="document-list">
                <div v-for="item in documentList" :key="item.id" @click="toOuterLink(item.hyperlink)" class="doc-title">
                    <svg-icon :iconName="renderFileType(item.docName)" size="16" class="mr-10"></svg-icon>
                    {{ item.docName }}
                </div>

            </div>
            </div>
            <div class="code-view">
                <img :src="$i18n.locale === 'en'?qrCodeEn:qrCodeCn" class="qr-code">
                <div class="font-bold">
                    {{ $t('newsMgt.title4') }}
                </div>
                <p>{{ $t('newsMgt.scanTips') }}</p>
                <img src="@/assets/img/icon-overview-phone.png" class="code-handle">
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import SvgIcon from "@/components/svgIcon/index";

export default{
    name:'ContentLeft',
    components:{ SvgIcon },
    data(){
        return{
            video_En:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_w9rnj0g7',
            video_Cn:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_ijojn7oa',
            video_yueyu:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_flmep6c5',
            video_title:'https://kpmgcn.mediaspace.sg.kaltura.com/media/t/0_mef2c9wg',
            eLearningUrl:'https://kpmgic.plateau.com/learning/user/deeplink.do?linkId=ITEM_DETAILS&componentID=5005716412&componentTypeID=WBT&fromSF=Y&revisionDate=1632963540000#/8A83C650F1F1E5C117008F0271A8F72D',
            newsList:[],
            materialsList:[],
            documentList:[],
            qrCodeCn:require(`@/assets/img/qrCodeCn.png`),
            qrCodeEn:require(`@/assets/img/qrCodeEn.png`)
        }
    },
    mounted(){
      this.getNews()
      this.queryKccUsefulDocuments()
      this.queryKccTrainingMaterials()
    },
    methods:{
        toOuterLink(url){
            if(!url) return
            window.open(url)
        },
        async getNews(){
            const { code, data }= await API.system.queryKccNews()
            if(code === '1'){
                this.newsList = data;
            }
        },
        async queryKccUsefulDocuments(){
            const { code, data }= await API.system.queryKccUsefulDocuments()
            if(code === '1'){
                this.documentList = data;
            }
        },
        async queryKccTrainingMaterials(){
            const { code, data }= await API.system.queryKccTrainingMaterials()
            if(code === '1'){
                const result = []
                for (let i = 0; i < data.length; i += 3) {
                    result.push(data.slice(i, i + 3))
                }
                this.materialsList = result;
            }
        },
        renderFileType(name){
            const fileType = name.substring(name.lastIndexOf(".")+1).toLowerCase()
            const iconName = fileType?'file-'+fileType:'file-pdf'
            return iconName
        }
    }
}
</script>
<style scoped>
.mb-5{
    margin-bottom: 5px;
}
.font-bold{
    font-weight: bold;
}
::v-deep .news-container .el-carousel__button{
    display: block;
    opacity: .3;
    background-color: #1e49e2;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: .3s;
    width: 10px;
    height: 10px;
    border-radius: 100%;
}

::v-deep .news-container .el-carousel__indicator.is-active button{
    opacity: 1;
}


::v-deep .news-container .el-carousel {
    height: calc(100% - 30px);
  }

::v-deep .news-container .el-carousel__container{
    height: 100%;
}

::v-deep .news-container .el-carousel__indicators--horizontal{
    right: 0;
    left: auto;
    transform: none;
}
.kcc-new-center{
    width: 30%;
    margin-right: 20px;
    height: 100%;
    border: 4px solid #c5cff0;
    border-radius: 12px;
    background: #fff;
}

.news-container{
    height: 30%;
    padding: 15px 15px 0 15px;
    background: #ffffff;
    min-height: 230px;
    border-radius: 12px 12px 0 0;
}

.news-pic{
    width: 220px;
    height: 140px;
    margin-right: 10px;
}

.material-pic{
    height: 80px;
}

.new-link{
    color: #00338D;
    font-size: 14px;
    cursor: pointer;
    margin-top:10px;
    display: flex;
    align-items: center;
    max-width: 50%;
}
.news-desc{
    color:#7d7d87;
    overflow: auto;
    max-height: 90px;
}

.link-title{
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
}

::v-deep .onboard-container .el-carousel__container{
    height: 100px;
}

::v-deep .onboard-container .el-carousel__arrow--right{
    top:40%;
    right: -10px;
    overflow: hidden;
}

::v-deep .onboard-container .el-carousel__arrow--left{
    top:40%;
    left: -10px;
    overflow: hidden;
}

.onboard-container{
    /* height: 42%; */
    margin:  0;
    /* background: #ffffff; */
    padding: 15px 15px 10px 15px;
    /* overflow: auto; */
    /* box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5) */
}
.video-fill{
    width: 16px;
    height: 16px;
}
.video-list-item{
    width: 50%;
}

.onboard-link{
    text-decoration: underline;
    color:#2f56e4;
    cursor: pointer;
    margin-right: 10px
}
.p-15{
    padding:10px;
    border-radius: 4px;
    font-size: 12px;
}
.pointer{
    cursor: pointer;
}
.bottom-splitLine{
    border-bottom: 1px dashed #e8e8e8;
    padding-bottom: 10px;
}
.material-title{
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    color:#7d7d87;
    font-size: 12px;
}
.w-32{
    width: 32%;
}
.w-50{
    width: 50%;
}

.w-32:nth-child(2n){
    margin:0 2%;
}

.learning-course{
    background: #00338D;
    padding: 5px 10px;
    border-radius: 4px;
    color:white;
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top:15px;
}

.training-container{
    height: calc(27% - 30px);
    /* box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5) */
}
.document-container{
    /* margin-right: 10px; */
    background-color: white;
    padding: 0 15px 10px 15px;
    width: calc(100% - 160px);
}
.document-list{
    height: calc(100% - 30px);
    overflow: auto;
}
.doc-title{
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    color:#7d7d87;
    margin: 10px 0;
    cursor: pointer;
}
.doc-title:hover{
    color: #1e49e2;
}
.code-view{
    width: 160px;
    background-size: contain;
    color: white;
    height: 100%;
    text-align: center;
    background: #678aeb;
    text-align: center;
    border-radius: 8px;
    padding: 15px;
    overflow: hidden;
    margin-right: 10px;
}

.qr-code{
    width: 72px;
    height: 72px;
}

.code-handle{
    width: 86px;
    margin-right: -100px;
}
</style>